import React, { useState, useEffect, useCallback } from "react";
import { getTrendingWPPostsThisMonth } from "../services/posts";
import { RESTPost } from "../services/types";
import BDPost from "../components/BDPost";
import AdSense from "../components/AdSense";
import PostSkeleton from "../components/PostSkeleton";
import Button from "../components/Button";

const TopThisMonthPage: React.FC = () => {
    const [posts, setPosts] = useState<RESTPost[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const loadPosts = useCallback(async (page: number, append: boolean = false) => {
        setLoading(true);
        setError(null);
        
        try {
            const response = await getTrendingWPPostsThisMonth(page);
            
            if (append) {
                setPosts(prevPosts => [...prevPosts, ...response.posts]);
            } else {
                setPosts(response.posts);
            }
            
            setTotalPages(response.totalPages);
        } catch (err) {
            setError('Failed to load posts');
            console.error('Error loading posts:', err);
        } finally {
            setLoading(false);
        }
    }, []);

    const loadMorePosts = useCallback(() => {
        if (currentPage < totalPages && !loading) {
            const nextPage = currentPage + 1;
            setCurrentPage(nextPage);
            loadPosts(nextPage, true);
        }
    }, [currentPage, totalPages, loading, loadPosts]);

    // Load initial posts
    useEffect(() => {
        loadPosts(1);
    }, [loadPosts]);

    const hasMorePosts = currentPage < totalPages;

    return (
        <>
            {loading && posts.length === 0 ? (
                <PostSkeleton count={5} />
            ) : (
                posts.map((post: RESTPost, index: number) => (
                    <React.Fragment key={post.id}>
                        <BDPost post={post} />
                        {/* Insert ad after 1st, 4th, and 6th posts */}
                        {(index === 0 || index === 3 || index === 5) && (
                            <AdSense />
                        )}
                    </React.Fragment>
                ))
            )}
            
            {hasMorePosts && (
                <div style={{ textAlign: 'center', padding: '2rem' }}>
                    <Button 
                        variant="secondary" 
                        size="medium" 
                        onClick={loadMorePosts}
                        loading={loading}
                    >
                        {loading ? 'Chargement...' : 'Charger plus de BDs populaires'}
                    </Button>
                </div>
            )}
            
            {error && (
                <div style={{ textAlign: 'center', padding: '2rem', color: 'red' }}>
                    {error}
                </div>
            )}
            
            {!hasMorePosts && posts.length > 0 && (
                <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
                    Aucune autre BD populaire !
                </div>
            )}
        </>
    );
};

export default TopThisMonthPage;
